import ProxyBase from '../../../../core/proxies/ProxyBase'

class UserProxy extends ProxyBase {
  getUserType(params) {
    return this.get('User/UserType', params)
  }
  getFEComponentAuthorized(params) {
    return this.get('UserManagement/FEComponentAuthorized', params)
  }

  postLoggedIn(params) {
    return this.get('User/LoggedIn', params)
  }
}

export default new UserProxy()
